<template>
  <div>
    <div style="font-size: 36px; font-weight: 700; margin-top: 80px; margin-bottom: 80px; text-align: center">Not yet
      open！</div>
    <!-- <h1>Southern Medical University</h1>
    <div class="u_separation" style="width: 1500px; margin-right: auto; margin-left: auto;">
      <p>Providing first-class international medical education and training high-end medical talents with international vision and competitiveness.</p>
    </div>
    <lm-swatches-block :space="43.75">
      <lm-container>
        <lm-row :md-gutter="35">
          <lm-col :md-span="8" v-for="article in list" :key="article.id">
            <lm-column style="margin-bottom: 35px;" :src="article.article_pic_syn" :title="article.article_title"
              :description="article.article_intro" :links="article.links"
              @click="artilceIdArticle(article.id, article.article_url)"></lm-column>
          </lm-col>
        </lm-row>
        <section class="btn-wrap" v-if="(pageNumber - 1) * pageSize < totalRow" @click="getPageData">
          <section class="primary-btn">More News</section>
        </section>
      </lm-container>
    </lm-swatches-block> -->
  </div>
</template>

<script>
import { frontArticles4Memu } from '@/api/api';
import { methodsMixins } from '@/mixins/index';

export default {
  mixins: [methodsMixins],
  data() {
    return {
      leadership: {
        pageNumber: 1,
        pageSize: 3,
        list: []
      },
      history: {
        pageNumber: 1,
        pageSize: 3,
        list: []
      },
      greetings: {
        pageNumber: 1,
        pageSize: 3,
        list: []
      },
      list: [{
        article_pic_syn: require('@/assets/temp/cc1.jpg'),
        article_title: 'Leadership',
        links: [{
          article_title: 'CurrentLeader'
        }, {
          article_title: 'Party Secratary'
        }, {
          article_title: 'Other Administration'
        }]
      }, {
        article_pic_syn: require('@/assets/temp/cc2.jpg'),
        article_title: 'History',
        links: [{
          article_title: 'SIE History'
        }, {
          article_title: 'SIE Then & Now'
        }, {
          article_title: 'SIE Timelines'
        }]
      }, {
        article_pic_syn: require('@/assets/temp/cc3.jpg'),
        article_title: 'Greetings',
        links: [{
          article_title: 'Dean’s Greeting'
        }, {
          article_title: 'Student Representative’s Greeting'
        }, {
          article_title: 'Write down your greetings'
        }]
      }]
    }
  },
  created() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      frontArticles4Memu({
        memu1Id: 'y0lm76pdhn',
        memu2Id: 'y0lm94qzja',
        pageNumber: this.leadership.pageNumber ++,
        pageSize: this.leadership.pageSize
      }).then(res => {
        this.list[0].links = res.data.list;
      })
      frontArticles4Memu({
        memu1Id: 'y0lm76pdhn',
        memu2Id: 'y0lwfctyhm',
        pageNumber: this.history.pageNumber ++,
        pageSize: this.history.pageSize
      }).then(res => {
        this.list[1].links = res.data.list;
      })
      frontArticles4Memu({
        memu1Id: 'y0lm76pdhn',
        memu2Id: 'y0lwfcu9rw',
        pageNumber: this.greetings.pageNumber ++,
        pageSize: this.greetings.pageSize
      }).then(res => {
        this.list[2].links = res.data.list;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';
@import '../home/index.scss';
</style>
